import { fork, put, take, all, call } from 'redux-saga/effects';
import { SAVE_TITLE } from 'reducers/dataModels';
import bindAndHandleEvents from 'lib/bindAndHandleEvents';
import { CREATE_PAGE_VIEWER, SET_IFRAME_ATTRIBUTES, GET_TOC } from './actions';
import { notifications, CREATE_PAGE_VIEWER_FAIL, SET_ISLOADING } from 'PipeRouter';
import { ensureMarkers } from 'lib/normalizers/markers';
import { GET_VS_MARKERS } from 'pipelines/actions';

function* ensureMarkersInBackground() {
  try {
    console.time('createPageViewer#ensureMarkers');
    yield call(ensureMarkers);
    yield put({ type: GET_VS_MARKERS });
    console.timeEnd('createPageViewer#ensureMarkers');
  } catch (err) {
    console.error(err);
    window.logger.error('ENSURE_MARKERS_FAIL', { err });
  }
}

function* createPageViewer(createPageObject) {
  while (true) {
    const { data:createPageObject } = yield take(CREATE_PAGE_VIEWER);

    try {
      console.log('createPageViewer#createPageViewer')
      console.time('createPageViewer#createPageViewer')

      const createPageViewResult = yield window.Crane.createPageViewer(createPageObject);
      console.timeEnd('createPageViewer#createPageViewer')

      const { bookData: data, viewer: vsViewer } = createPageViewResult;

      window.vsBookData = data;
      window.vsViewer = vsViewer;
      // window.vsViewer.Viewport.setAutofocus(false);

      console.time('createPageViewer#bindAndHandleEvents')
      yield fork(bindAndHandleEvents);
      console.timeEnd('createPageViewer#bindAndHandleEvents')

      console.time('createPageViewer#SET_ISLOADING')
      yield all([
        put({ type: SAVE_TITLE, title: data.title }),
        put({ type: GET_TOC }),
        put({ type: SET_IFRAME_ATTRIBUTES }),
        put(notifications(SET_ISLOADING, false))
      ]);
      console.timeEnd('createPageViewer#SET_ISLOADING')

      yield fork(ensureMarkersInBackground);
    } catch (err) {
      window.logger.error('CREATE_PAGE_VIEWER_FAIL', { err });
      yield put(notifications(CREATE_PAGE_VIEWER_FAIL));
    }
  }
}


export default createPageViewer;
